export const AUTHORIZATION = "AUTHORIZATION";
export const SET_LOGIN = "SET_LOGIN";
export const LOGOUT = "LOGOUT";

export const LANGUAGE_REFS = "LANGUAGE_REFS";
export const SYSTEM_REFS = "SYSTEM_REFS";
export const COUNTRY_REFS = "COUNTRY_REFS";
export const CITY_REFS = "CITY_REFS";
export const REFERENCE_REFS = "REFERENCE_REFS";
export const ATTRIBUTE_TYPE_REFS = "ATTRIBUTE_TYPE_REFS";
export const REFERENCE_SPECIFIC = "REFERENCE_SPECIFIC";
export const REFERENCE_CLEAR = "REFERENCE_CLEAR";

export const ATTRIBUTE_TEMPLATES_GET = "ATTRIBUTE_TEMPLATES_GET";
export const ATTRIBUTE_TEMPLATES_CLEAR = "ATTRIBUTE_TEMPLATES_CLEAR";
export const ATTRIBUTE_TEMPLATES_CREATE = "ATTRIBUTE_TEMPLATES_CREATE";
export const ATTRIBUTE_TEMPLATES_UPDATE = "ATTRIBUTE_TEMPLATES_UPDATE";
export const ATTRIBUTE_TEMPLATES_DELETE = "ATTRIBUTE_TEMPLATES_DELETE";

export const OBJECT_TYPES_GET = "OBJECT_TYPES_GET";
export const OBJECT_TYPES_CREATE = "OBJECT_TYPES_CREATE";
export const OBJECT_TYPES_UPDATE = "OBJECT_TYPES_UPDATE";
export const OBJECT_TYPES_CLEAR = "OBJECT_TYPES_CLEAR";

export const OBJECT_TEMPLATES_READ = "OBJECT_TEMPLATES_READ";
export const OBJECT_TEMPLATES_CREATE = "OBJECT_TEMPLATES_CREATE";
export const OBJECT_TEMPLATES_UPDATE = "OBJECT_TEMPLATES_UPDATE";
export const OBJECT_TEMPLATES_DELETE = "OBJECT_TEMPLATES_DELETE";
export const OBJECT_TEMPLATES_CLEAR = "OBJECT_TEMPLATES_CLEAR";

export const OBJECTS_LIST_READ = "OBJECTS_LIST_READ";
export const OBJECTS_READ = "OBJECTS_READ";
export const OBJECTS_COPY_READ = "OBJECTS_COPY_READ";
export const OBJECTS_CREATE = "OBJECTS_CREATE";
export const OBJECTS_UPDATE = "OBJECTS_UPDATE";
export const OBJECTS_DELETE = "OBJECTS_DELETE";
export const OBJECTS_LIST_CLEAR = "OBJECTS_LIST_CLEAR";
export const OBJECTS_CLEAR = "OBJECTS_CLEAR";
export const OBJECTS_COPY_CLEAR = "OBJECTS_COPY_CLEAR";
export const OBJECTS_FILTER_GET = "OBJECTS_FILTER_GET";
export const OBJECTS_FILTER_SAVE = "OBJECTS_FILTER_SAVE";
export const OBJECTS_NAVIGATION_SET = "OBJECTS_NAVIGATION_SET";
export const OBJECTS_NAVIGATION_SELECT = "OBJECTS_NAVIGATION_SELECT";
export const OBJECTS_INFO = "OBJECTS_INFO";
export const OBJECTS_ANY_PARAMS_CLEAR = "OBJECTS_ANY_PARAMS_CLEAR";

export const ATTR_VALUE_CREATE = "ATTR_VALUE_CREATE";
export const ATTR_VALUE_UPDATE = "ATTR_VALUE_UPDATE";
export const ATTR_VALUE_DELETE = "ATTR_VALUE_DELETE";
